export default {
  LAST_NAME: "ANAAM",
  INITIALS: "VOORL",
  SUFFIX: "VOORV",
  GENDER: "GESLACH",
  DOB: "GEBDAT",
};
